module.exports = __webpack_public_path__ + "media/images/river/crewneck-v-black-d24c0425d5124f1e7f270a6f1a218a35.jpg";